import { create } from "zustand";
import { getConditionsOfHookLoaderVehiclesReportList } from "../../inspectionReportApi";
import {
  fetchInspectionReportExportData,
  getInspectionReportDefaultFilters,
} from "../../store/inspectionReportStoreUtils";

const defaultFilters = getInspectionReportDefaultFilters();

const DEFAULT_PAGE_SIZE = 10;

export const useConditionsOfHookLoaderVehiclesStore = create((set, get) => ({
  rows: [],
  filters: { ...defaultFilters },
  isLoading: false,
  page: 0,
  pageSize: DEFAULT_PAGE_SIZE,
  totalRecords: 0,

  loadPage: async ({ filters, page, pageSize }) => {
    set({ isLoading: true, filters: { ...filters }, page, pageSize });

    try {
      const response = await getConditionsOfHookLoaderVehiclesReportList({
        ...filters,
        pageNumber: page + 1,
        pageSize,
      });

      set({
        rows: response.data,
        totalRecords: response.totalRecords,
        isLoading: false,
      });
    } catch (error) {
      console.error(
        "Failed to load Conditions of Hook-loader vehicles report:",
        error
      );
      set({ rows: [], totalRecords: 0, isLoading: false });
    }
  },

  fetchReport: async (nextFilters = get().filters) => {
    await get().loadPage({
      filters: nextFilters,
      page: 0,
      pageSize: get().pageSize,
    });
  },

  changePage: async (page) => {
    await get().loadPage({
      filters: get().filters,
      page,
      pageSize: get().pageSize,
    });
  },

  changePageSize: async (pageSize) => {
    await get().loadPage({
      filters: get().filters,
      page: 0,
      pageSize,
    });
  },

  resetFilters: async () => {
    await get().loadPage({
      filters: getInspectionReportDefaultFilters(),
      page: 0,
      pageSize: get().pageSize,
    });
  },

  fetchExportData: async () =>
    fetchInspectionReportExportData(
      getConditionsOfHookLoaderVehiclesReportList,
      get(),
      "Failed to load Conditions of Hook-loader vehicles report for export:"
    ),
}));
